import randomColor from 'randomcolor';
import React, { PropsWithChildren, ReactElement, useCallback } from 'react';

export type ColorPreferenceContextValue = {
  getSoundColor: (slug: string) => string;
  getIndexColor: (idx: number) => string;
  getMonitorColor: (id: number | string, idx: number, total?: number) => string;
  getMeasureColor: (measure: string) => string;
};

export const ColorPreferenceContext =
  React.createContext<ColorPreferenceContextValue>(undefined!);

type ColorPreferenceProviderProps = PropsWithChildren;

const ColorPreferencePreferredColor: Record<string, string> = Object.freeze({
  // NOTE: Currently disabled as these colors are pending review.
  snore: '#ffe0ae',
  'water-running': '#25c0c0',
  scream: '#f54d3d',
  clap: '#fd8b15',
  thud: '#9ab198',
  gasp: '#9ea7ca',
  footstep: '#3d5b59'
});

const ColorPreferencePreferredColorList: readonly string[] = Object.freeze(
  Object.values(ColorPreferencePreferredColor)
);

export const ColorPreferenceProvider = ({
  children
}: ColorPreferenceProviderProps): ReactElement => {
  const getSoundColor = useCallback((slug: string): string => {
    // NOTE: Currently disabled as these colors are pending review.
    //return ColorPreferencePreferredColor[slug] ?? randomColor({ seed: slug });
    return randomColor({ seed: slug });
  }, []);
  const getIndexColor = useCallback((idx: number): string => {
    return ColorPreferencePreferredColorList[
      idx % ColorPreferencePreferredColorList.length
    ]!;
  }, []);
  const getMonitorColor = useCallback(
    (_id: number | string, idx: number, total: number = 7): string => {
      if (total == 1) {
        return '#a49d9a';
      }
      const opacity = Math.floor(((30 + 70 * (idx / total)) / 100) * 256);
      return '#a49d9a' + opacity.toString(16).padStart(2, '0');
    },
    []
  );
  const getMeasureColor = useCallback((measure: string) => {
    switch (measure) {
      case 'response':
        return '#4e4e4e';
      case 'attendance':
      case 'check-in':
        return '#f2b13d';
      case 'aid-call':
        return '#9F2B68';
      case 'note':
        return '#FFFFFF';
      case 'fall':
        return '#FF0000';
      case 'time_in_room':
      case 'time_in_room_verified':
        return '#8E44AD';
      default:
        return randomColor({ seed: measure });
    }
  }, []);
  const value = {
    getSoundColor,
    getIndexColor,
    getMonitorColor,
    getMeasureColor
  };
  return (
    <ColorPreferenceContext.Provider value={value}>
      {children}
    </ColorPreferenceContext.Provider>
  );
};
